import Flex from '@react-css/flex';
import { useNavigate, useLocation } from 'react-router-dom';
import Body from 'storybookConfig/stories/molecules/Body';
import TertiaryButton from 'storybookConfig/stories/molecules/Button/TertiaryButton';
import Heading from 'storybookConfig/stories/molecules/Heading';
import Icon from 'storybookConfig/stories/molecules/Icon';
import SupportLink from 'storybookConfig/stories/molecules/Link/SupportLink';
import AuthLayout from 'storybookConfig/stories/species/Layout/AuthLayout';

const SignInSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <AuthLayout>
      <Flex column gap="32px">
        <Flex column gap="32px">
          <Icon name="mail-check" size="48px" color="bodyTextPrimary" aria-hidden="true" />

          <Heading variant="Headings/H2">Please check your email for a secure log in link.</Heading>

          <Body>
            We&apos;ve sent an email to{' '}
            {location.state?.email ? <strong>{location.state.email}</strong> : 'your email address'}
            . Click the link in the email to activate your account.
          </Body>
        </Flex>

        <Flex column gap="24px">
          <Flex column gap="8px">
            <Heading variant="Headings/H4" as="strong">
              Questions?
            </Heading>

            <Body>Didn&apos;t receive an email? Check your spam folder.</Body>

            <Body>
              Learn more about Carro’s{' '}
              <SupportLink href="https://moderndropship.frontkb.com/en/articles/8868545">
                passwordless log in
              </SupportLink>
              .
            </Body>

            <Body>
              Having issues? <a href="mailto:support@getcarro.com">Contact Support</a>.
            </Body>
          </Flex>

          {location.state?.backPath && (
            <Flex.Item>
              <TertiaryButton
                $iconName="chevron-left"
                onClick={() => navigate(location.state.backPath!)}
                $removePadding="left"
              >
                Back
              </TertiaryButton>
            </Flex.Item>
          )}
        </Flex>
      </Flex>
    </AuthLayout>
  );
};

export default SignInSuccessPage;
